var _style, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3600 3600",
    style: {
      enableBackground: "new 0 0 3600 3600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1800,3600C805.5,3600,0,2794.5,0,1800S805.5,0,1800,0s1800,805.5,1800,1800S2794.5,3600,1800,3600z M1800,180 C904.5,180,180,904.5,180,1800c0,292.5,81,571.5,216,810c328.5-409.5,837-675,1404-675s1075.5,261,1404,675 c139.5-238.5,216-513,216-810C3420,904.5,2695.5,180,1800,180z M1800,1755c-346.5,0-630-283.5-630-630s283.5-630,630-630 s630,283.5,630,630S2146.5,1755,1800,1755z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTrue);
export default __webpack_public_path__ + "static/media/profile-true.2d9c74d5bfa7606e0362259ba75bdd99.svg";
export { ForwardRef as ReactComponent };